import React from 'react';
import { twMerge } from 'tailwind-merge';

import BareBuilderSection from './BareBuilderSection';

interface BuilderSectionProps extends React.HTMLAttributes<HTMLElement> {
  bgClassNames?: string;
  className?: string;
  heading?: string;
  headingClassNames?: string;
  subheading?: string;
}

const BuilderSection: React.FC<BuilderSectionProps> = ({
  bgClassNames = '',
  className = '',
  children = null,
  heading = '',
  headingClassNames = 'text-gray-900 text-center lg:text-left font-sans text-2xl',
  subheading = '',
  ...props
}) => (
  <BareBuilderSection
    bgClassNames={bgClassNames}
    className={twMerge(
      'max-w-1440px px-6 py-16 md:px-12 md:py-24 lg:px-24 w-full mx-auto flex flex-col',
      className
    )}
    {...props}
  >
    {heading && (
      <h2 className={twMerge('block mb-6 font-bold', headingClassNames)}>
        {heading}
      </h2>
    )}

    {subheading && (
      <div
        className="mb-6 text-base font-normal"
        dangerouslySetInnerHTML={{ __html: subheading }}
      ></div>
    )}

    {children}
  </BareBuilderSection>
);

export default BuilderSection;
